"use client";

import { c as _c } from "react/compiler-runtime";
import { Checkbox, SkeletonLine } from "@opensea/ui-kit";
import { useShallow } from "zustand/react/shallow";
import { useIsOwnProfileAddress } from "@/components/profile/ProfileAddressProvider";
import { useItemsCount } from "../ItemsCount";
import { useItemsChecked } from "../ItemsCount/hooks";
import { useProfileItemsSelectionStore } from "./ProfileItemsSelectionProvider";
export function ProfileItemsSelectAllCheckbox(t0) {
  const $ = _c(5);
  const {
    disabled: t1
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const [selectAllItems, isLoadingItems] = useProfileItemsSelectionStore(useShallow(_temp));
  const checked = useItemsChecked();
  const itemsCount = useItemsCount();
  const isOwnProfile = useIsOwnProfileAddress();
  if (!isOwnProfile) {
    return null;
  }
  if (isLoadingItems || itemsCount?.fetching) {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <SkeletonLine className="size-4" />;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    return t2;
  }
  let t2;
  if ($[1] !== checked || $[2] !== disabled || $[3] !== selectAllItems) {
    t2 = <Checkbox checked={checked} disabled={disabled} onCheckedChange={selectAllItems} />;
    $[1] = checked;
    $[2] = disabled;
    $[3] = selectAllItems;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function _temp(v) {
  return [v.selectAllItems, v.isLoadingItems];
}